import { Alert, Badge, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Title = styled.h2`
  ${typographyV2.titleSm};
  margin-bottom: 4px;
`;

export const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Text = styled.p`
  color: var(--text-soft);
  margin-bottom: 8px;
  ${typographyV2.bodySm};
`;

export const StyledAlert = styled(Alert)`
  width: 100%;
`;

export const StyledBadge = styled(Badge)`
  cursor: pointer;
`;
